<section class="step-two-layout" [class.preview-mode]="mode === 'preview'">
  <svg class="field-icon-sprite" aria-hidden="true" focusable="false">
    <defs>
      <symbol id="icon-signature" viewBox="0 0 24 24"><path d="M4 17c4 0 6-6 9-6 1 0 2 .7 2 2 0 2-2 3-4 3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 20h16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-initials" viewBox="0 0 24 24"><path d="M5 18V6M12 18V6M12 12h7M19 18V6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-textbox" viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 10h8M8 14h5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-date" viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 4v4M16 4v4M4 10h16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-checkbox" viewBox="0 0 24 24"><rect x="5" y="5" width="14" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 12l3 3 5-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></symbol>
      <symbol id="icon-radio" viewBox="0 0 24 24"><circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="2.8" fill="none" stroke="currentColor" stroke-width="1.8"/></symbol>
      <symbol id="icon-person" viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M6 19c1.2-2.8 3.2-4.2 6-4.2S16.8 16.2 18 19" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-email" viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="m6 8 6 5 6-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></symbol>
      <symbol id="icon-briefcase" viewBox="0 0 24 24"><rect x="4" y="8" width="16" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9 8V6h6v2M4 13h16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></symbol>
      <symbol id="icon-image" viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="10" r="1.4" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="m8 16 3-3 2.5 2 2.5-2.5 2 2.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></symbol>
      <symbol id="icon-dropdown" viewBox="0 0 24 24"><rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="m9 11 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></symbol>
    </defs>
  </svg>

  @if (mode === 'configure') {
    <aside class="configure-left">
      <div class="configure-left__tools">
        <div class="left-title">
          <h2>Fields</h2>
          <span class="info-dot">i</span>
        </div>
        <p class="drag-hint">Drag a field tile onto the PDF to place it.</p>

        <label for="activeActorSelect" class="small-label">{{ actorSelectLabel }}</label>
        <select id="activeActorSelect" class="rail-select actor-select" [ngModel]="activeActorId" [disabled]="mode !== 'configure'" (ngModelChange)="activeActorIdChange.emit($event)">
          @for (actor of actors; track actor.id) {
            <option [value]="actor.id">{{ actor.label }}</option>
          }
        </select>

        <div class="field-palette">
          @for (item of fieldPalette; track item.type) {
            <button
              type="button"
              class="field-pill"
              [disabled]="!canPlaceFields"
              [draggable]="canPlaceFields"
              (dragstart)="paletteDragStart.emit({ event: $event, type: item.type })"
              (dragend)="paletteDragEnd.emit()"
              (click)="paletteTileClick.emit(item.type)"
            >
              <svg class="field-pill-icon" aria-hidden="true" focusable="false">
                <use [attr.href]="'#icon-' + item.iconId"></use>
              </svg>
              <span class="field-pill-label">{{ item.label }}</span>
            </button>
          }
        </div>

        @if (showWalkthroughButton) {
          <button type="button" class="show-walkthrough" (click)="walkthroughRequest.emit()">Show walkthrough</button>
        }
      </div>

      @if (stepTwoError) {
        <p class="field-error step-two-error">{{ stepTwoError }}</p>
      }
    </aside>
  }

  <app-field-configurator-canvas
    [viewerPdfSource]="viewerPdfSource"
    [hasPendingSource]="hasPendingSource"
    [emptyNoFileMessage]="emptyNoFileMessage"
    [emptyPreparingMessage]="emptyPreparingMessage"
    [pdfLoadError]="pdfLoadError"
    [pdfLoadErrorDetail]="pdfLoadErrorDetail"
    [pdfBootstrapError]="pdfBootstrapError"
    [showViewerInstance]="showViewerInstance"
    [viewerRenderNonce]="viewerRenderNonce"
    [viewerPageBinding]="viewerPageBinding"
    [viewerRotation]="viewerRotation"
    [pdfLoading]="pdfLoading"
    [canPlaceFields]="canPlaceFields"
    [fieldCount]="fields.length"
    [retryButtonLabel]="retryButtonLabel"
    [showStepOneButton]="showStepOneButton"
    [stepOneButtonLabel]="stepOneButtonLabel"
    (goToStepOne)="goToStepOne.emit()"
    (retryPreview)="retryPreview.emit()"
    (pdfLoadingStarts)="pdfLoadingStarts.emit()"
    (pdfLoaded)="pdfLoaded.emit()"
    (pdfLoadingFailed)="pdfLoadingFailed.emit($event)"
    (pagesLoaded)="pagesLoaded.emit($event)"
    (pageRendered)="pageRendered.emit($event)"
    (pageChange)="pageChange.emit($event)"
    (rotationChange)="rotationChange.emit($event)"
  >
    <ng-content select="[canvas-debug]"></ng-content>
  </app-field-configurator-canvas>

  <aside class="configure-right">
    @if (mode === 'configure') {
      <app-field-settings-panel
        [title]="settingsTitle"
        [selectedField]="selectedField"
        [actors]="actors"
        [panelOptions]="settingsPanelOptions"
        [optionSets]="optionSets"
        [positionX]="positionX"
        [positionY]="positionY"
        [checkboxGroupName]="checkboxGroupName"
        [checkboxGroupValues]="checkboxGroupValues"
        [checkboxGroupDefaultValues]="checkboxGroupDefaultValues"
        [radioGroupName]="radioGroupName"
        [radioGroupValues]="radioGroupValues"
        [radioGroupDefaultValue]="radioGroupDefaultValue"
        (action)="settingsAction.emit($event)"
      ></app-field-settings-panel>
    } @else {
      <app-field-preview-panel
        [actors]="actorSummaries()"
        [previewFilter]="previewFilter"
        [previewMeta]="previewMeta"
        [pageCount]="pageCount"
        [totalFields]="visibleSummaryCount()"
        (previewFilterChange)="previewFilterChange.emit($event)"
        (previewMetaChange)="previewMetaChange.emit($event)"
      ></app-field-preview-panel>
    }
  </aside>

  <ng-content select="[workspace-overlay]"></ng-content>
</section>
